import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import EditUser from "../userBlock/ViewUser";
import View from "./View";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

const ListReceived = () => {
  const [approvedList, setApprovedList] = useState([]);
  const [unapprovedList, setUnApprovedList] = useState([]);
  const [receiptList, setReceiptList] = useState({})
  const [approveChange, setApproveChange] = useState(false)

  const printRef = useRef()
  const printAprovedList = useRef()


  useEffect(() => {
    api
      .get("/transactions/receipts/?is_approved=true")
      .then((response) => {
        setApprovedList(response.data);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  }, [approveChange]);




  useEffect(() => {
    api
      .get("/transactions/receipts/?is_approved=false")
      .then((response) => {
        setUnApprovedList(response.data);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  }, [approveChange]);



  const handleApprove = (receiptId) => {

    api.post(`/transactions/receipts/${receiptId}/approve/`)
      .then(response => {
        toast.success("Receipt approve successfully")
        setApproveChange(!approveChange)
        // setReceiptId(null)
      }).catch(error => {
        toast.error("Something went wrong")
      })

  }

  
  const handleSearch = (e, name) => {

    if(name === "approve"){
    api.get(`transactions/receipts/?is_approved=true&search=${e.target.value}`)
    .then(response=> {
      // console.log(response.data)
      // setDisplayTask(response.data)
      setApprovedList(response.data)
    }).catch(error=> {
      console.log(error)
    })
  }else {
    api.get(`transactions/receipts/?is_approved=false&search=${e.target.value}`)
    .then(response=> {
      
      setUnApprovedList(response.data)
    }).catch(error=> {
      console.log(error)
    })
  }

}





  const print = useReactToPrint({
    content: () => printRef.current
  })
  const printAproved = useReactToPrint({
    content: () => printAprovedList.current

  })
  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Receipt List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      {/* Approve गर्न बाँकी List */}
      <div className="w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="wrapper overflow-atuo">
                {/* search */}
                <p className="text-primary-red mt-5 font-bold underline">
                  Approve गर्न बाँकी List
                </p>
                <div className="flex items-center justify-between">
                  <input
                    placeholder="Search Entry Date"
                    type="search"
                    onChange={(e)=> handleSearch(e, "unapprove")}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search Staff Name"
                    type="search"
                    onChange={(e)=> handleSearch(e, "unapprove")}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search Company Name"
                    type="search"
                    onChange={(e)=> handleSearch(e, "unapprove")}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                </div>
                <table ref={printRef} className="common w-full border-collapse text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="!w-[20px] px-4 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Receipt No.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Create Date
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Company name
                      </th>

                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Received Amound
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    

                    {unapprovedList.map((item, i) => {
                      // console.log("reciept list ", item)
                      return (
                        <tr className="trow border-b bg-white" key={i}>
                          <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                            {i}
                          </td>
                          <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                            {item.id}
                          </td>
                          <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                            {item.created_at}
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            {item.company_name}
                          </td>

                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            {item.paid_amount}
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            <button
                              onClick={() => {setReceiptList(item)}}
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalEdit"
                              className="bg-primary-green rounded-full p-1 px-2 text-white"
                            >
                              View
                            </button>
                            <View receiptList={receiptList} />

                            <button
                              onClick={() => handleApprove(item.id)}
                              className="bg-primary-blue rounded-full p-1 px-2 text-white"
                            >
                              Approve
                            </button>
                          </td>
                          <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                            {item.status}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {/* print button */}
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <button onClick={print}>Print</button>
                </div>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <button href="">View More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
      {/* table  */}
      {/* Approved List */}
      <div className="w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="wrapper overflow-atuo">
                {/* search */}
                <p className="text-primary-red mt-5 font-bold underline">
                  Approved List
                </p>
                <div className="flex items-center justify-between">
                  <input
                    placeholder="Search Entry Date"
                    type="search"
                    onChange={(e)=> handleSearch(e, "approve")}

                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    onChange={(e)=> handleSearch(e, "approve")}
                    placeholder="Search Staff Name"
                    type="search"
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    onChange={(e)=> handleSearch(e, "approve")}
                    placeholder="Search Branch Name"
                    type="search"
                    className="my-3 rounded-lg border border-black p-3"
                  />
                </div>
                <table ref={printAprovedList} className="common w-full border-collapse text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="!w-[20px] px-4 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        ReceiptNo.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Create Date
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Company name
                      </th>
                      {/* <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Company Name
                      </th> */}
                      {/* <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Staff Name
                      </th> */}
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Received Amount
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {
                      approvedList.map((item, i) => {
                        return (
                          <tr className="trow border-b bg-white">
                            <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                              {i + 1}
                            </td>
                            <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                              {item.id}
                            </td>
                            <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                              {item.created_at}
                            </td>
                            <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                              {item.company_name}
                            </td>
                            {/* <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Account
                      </td> */}
                            {/* <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Shila Pokherel
                      </td> */}
                            <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                              {item.paid_amount}
                            </td>
                            <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                              <button
                                onClick={() => setReceiptList(item)}
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModalEdit"
                                className="bg-primary-green rounded-full p-1 px-2 text-white"
                              >
                                View
                              </button>
                              <View />
                            </td>
                            <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                              {item.status}
                            </td>
                          </tr>
                        )
                      })
                    }

                    {/* <tr className="trow border-b bg-white">
                      <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                        2078/9/10
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Head Office
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Account
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Shila Pokherel
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        10000
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        <a
                          href=""
                          className="bg-primary-green rounded-full p-1 px-2 text-white"
                        >
                          View
                        </a>
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        Approved
                      </td>
                    </tr> */}
                  </tbody>
                </table>
                {/* print button */}
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <button onClick={printAproved}>Print</button>
                </div>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <a href="">View More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default ListReceived;
